import { Divider } from '@pets-ui/Divider/Divider'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const styles = stylex.create({
  expandContent: {
    backgroundColor: colors.grey50,
  },
})

export interface CollapseProductContentProps {
  children: ReactNode
}

export const CollapseProductContent = ({ children }: CollapseProductContentProps) => {
  return (
    <VStack marginTop="8px" rootStyle={styles.expandContent} divider={<Divider color={colors.grey200} />}>
      {children}
    </VStack>
  )
}
